import * as React from 'react';
import Switch from '@material-ui/core/Switch';

const CustomSwitch = (props) => {
    return <Switch {...props} />;
};

export { CustomSwitch as Switch };
